import { render } from "./BFormDatepicker.vue?vue&type=template&id=e5810bfe"
import script from "./BFormDatepicker.vue?vue&type=script&lang=js"
export * from "./BFormDatepicker.vue?vue&type=script&lang=js"

import "./BFormDatepicker.vue?vue&type=style&index=0&id=e5810bfe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__